/**
 * Factory for creating reducers with action handlers.
 */
const reducerUtils = {
  createReducer: function (initialState, handlers) {
    return function reducer(state = initialState, action) {
      if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
        return handlers[action.type](state, action)
      } else {
        return state
      }
    }
  },
}

export default reducerUtils
